import { create } from "zustand";

/** High-intent moments that may show the soft notification prompt (never on first load). */
export type PromptReason = "chat" | "order" | "listing" | "payment" | "settings";

interface PromptState {
  open: boolean;
  reason: PromptReason | null;
  asked: boolean; // once per session
  ask: (reason: PromptReason) => void;
  close: () => void;
}

export const usePushPrompt = create<PromptState>((set, get) => ({
  open: false,
  reason: null,
  asked: false,
  ask: (reason) => {
    if (get().open || (get().asked && reason !== "settings")) return;
    set({ open: true, reason, asked: true });
  },
  close: () => set({ open: false }),
}));

/** Call after a high-intent action, e.g. `askForPush("chat")` once the first message is sent. */
export function askForPush(reason: PromptReason): void {
  usePushPrompt.getState().ask(reason);
}
